import React, { createContext, useState } from 'react';

export const FormValuesContext = createContext([] as any[]);
type changeCustomReceiversProps = {
  index: number;
  value: string;
};

export const FormValuesContextProvider = (props: any) => {
  const [customReceivers, setCustomReceivers] = useState({});

  const changeCustomReceivers = ({
    index,
    value,
  }: changeCustomReceiversProps) => {
    setCustomReceivers({
      index,
      value,
    });
  };

  return (
    <FormValuesContext.Provider
      value={[customReceivers, changeCustomReceivers]}
    >
      {props.children}
    </FormValuesContext.Provider>
  );
};
